import { forwardRef } from 'react';
import { Box } from '@alf/uikit';
import { Icon } from '@namespace/icons2';
import { Arrow } from '../MarketDescriptionTooltip/Arrow';

import styles from './index.module.css';

export const MarketDescriptionTrigger = forwardRef(
  ({ onClick, isOpen }, ref) => (
    <Box ref={ref}>
      <Icon
        name={`icons/general/state/${isOpen ? 'info' : 'info2'}`}
        size="s"
        color="state_info"
        onClick={onClick}
      />
      {isOpen && <Arrow className={styles.arrow} />}
    </Box>
  )
);
